/**
 * GET /auth/list-tokens - List personal access tokens
 */

import type { ActionDefinition } from '@gzl10/nexus-sdk'
import type { MiddlewareHandler } from 'hono'
import type { AuthService } from '../auth.service.js'

export const listTokensAction: ActionDefinition = {
  key: 'list-tokens',
  label: { en: 'List Personal Tokens', es: 'Listar tokens personales' },
  icon: 'mdi:key-chain',
  scope: 'module',
  group: { en: 'Personal Tokens', es: 'Tokens personales' },
  method: 'GET',
  middleware: (ctx) => ctx.core.middleware['auth'] as MiddlewareHandler,
  handler: async (ctx, input) => {
    const { _authUserId } = input as { _authUserId?: string }
    if (!_authUserId) throw new ctx.core.errors.UnauthorizedError('Usuario no autenticado')
    const authService = ctx.services.get<AuthService>('auth')
    return authService.listPersonalTokens(_authUserId)
  }
}
